/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { postData } from '../../util/index'
import { message } from 'antd'
import { GETADDCLUBINFO } from './constants'

export const getAddClubInfo = (payload) => {
  return {
    type: GETADDCLUBINFO,
    payload,
  }
}

//增加
export function fetchAddClub(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Manage/ClubApi/AddClub`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getAddClubInfo(data))
      if (data.status === true) {
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubAdd/action.js